import React, { useEffect, useMemo, useRef, useState } from 'react'
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import debounce from 'lodash.debounce';
import axios from 'axios'
import { Helmet } from 'react-helmet';
import { Button, Card, Container, Input } from '../../Components';
import { useDispatch, useSelector } from 'react-redux';
import { updateOrganizationPages, updateOrganizationPagesByID, updateUserOrganizationPageByID } from '../../Redux/features/authSlice';
import Tooltip from 'rc-tooltip';
import {IoIosWarning} from 'react-icons/io'
import {FiCopy} from 'react-icons/fi'
import {BsCheckCircleFill} from 'react-icons/bs'
import {getIndexDomainName} from '../../Helpers/string'
import './page.settings.css'
import { useCopyToClipboard } from 'react-use';

export function PageSettingsDomains() {

	const regex_validator = {
		subdomain : /^[A-Za-z0-9\-\_]+$/,
		custom_domain : /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/
		
	}

	const { page_id } = useParams();
	const navigate = useNavigate();
	const effectCalled = useRef(false)
	const { user , org } = useSelector((state) => state.auth)
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(false)
	const [isLoadingStatuspageData, setIsLoadingStatuspageData] = useState(false)
	const [isCheckingSubdomain, setIsCheckingSubdomain] = useState(false)
	const [isCheckingCustomDomain, setIsCheckingCustomDomain] = useState(false)

	const [formData, setFormData] = useState({
		hosted_subdomain: "",
		custom_domain: "",
		custom_domain_verify_status: "",
		custom_domain_verification_id: "",
	});
	const [formValidation, setFormValidation] = useState({
		hosted_subdomain : "",
		custom_domain : "",
		 
	})

	const [state, copyToClipboard] = useCopyToClipboard();

	useEffect(() => {

		async function processTasks(){
			if(state?.error) toast.error('Not copied!' ,{ position : 'bottom-right'});
			else if(state?.value) toast.success('Copied!' , {
				position: "bottom-right"
			})
		}

		processTasks();

	}, [state])


	useEffect(() => {

		if(effectCalled.current){ return ;}
		 
		async function fetchData() {
			
			await getStatuspageData();
		}
		fetchData();

		effectCalled.current = true ;
	  
	}, [])



	/**
	 * 
	 * @returns 
	 */
	const getStatuspageData = () => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingStatuspageData(true)
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { }

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					setFormData( (prevState) => ({ 
						...prevState,
						hosted_subdomain: data?.hosted_subdomain ?? '',
						custom_domain: data?.custom_domain ?? '',
						custom_domain_verify_status: data?.custom_domain_verify_status ?? '',
						custom_domain_verification_id: data?.custom_domain_verification_id ?? '',
						plan : data?.plan
					}))

					 
					 

					setIsLoadingStatuspageData(false)
		
					resolve(data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					if(error?.response?.data?.error ==='NOT_FOUND'){
						navigate('/pages')
					}
					setIsLoadingStatuspageData(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingStatuspageData(false)
			}

		})
	} 

	


	/**
	 * 
	 * @param {*} e 
	 * @returns 
	 */
	const onSubmit = async (e) => {
		e.preventDefault();

		return new Promise( async (resolve, reject) => { 
			
			setIsLoading(true)
			let validationSubdomain = ''// (formData.hosted_subdomain.match(regex_validator.subdomain)===null) ? 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"' : ''
			// ! Check the syntaxe 
			if(formData.hosted_subdomain.match(regex_validator.subdomain)===null){
				validationSubdomain = 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"'  
				
			}else{
				validationSubdomain = 'The selected subdomain is not available!'
				// ! Check the availability 
				try {
					const response = await checkSubdomainAvailability(formData.hosted_subdomain)
					
					if(response && response?.availability === true ) validationSubdomain = '';
					

				} catch (error) {}

				
			}
			setFormValidation((prevState) => ({
				...prevState,
				hosted_subdomain: (formData.hosted_subdomain === '') ? "Subdomain can't be blank." : '',
			}))

			if(validationSubdomain !=='' ){

				toast.error("Please complete all required fields")
				setIsLoading(false)

				return 
			}

			
			
			
			
			
			if (user && user.token && org && org?.id && formData?.id !==null ) {

				
				let params = { 
					hosted_subdomain : formData?.hosted_subdomain,
					custom_domain : formData?.custom_domain,
				}
				

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsLoading(false)
					toast.success('Your page has been successfully updated')

					updateReduxPageInfo(data);
					
		
					resolve(data.data) 
		
				})
				.catch(error => {
					//console.log(error)
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.')
					 
				})
			}else{
				setIsLoading(false)
				toast.error('Something went wrong, please try again later.')
				 
			}


		})

	}

	// ! SUB DOMAIN CHECKING ....
	/**
	 * 
	 * @param {*} subdomain 
	 */
	const checkSubdomainAvailability = async (subdomain) => {
		
		return new Promise(async (resolve, reject) => { 


	
			if(user && user.token){

				const { token } = user 
	
				await axios
				.post(`${process.env.REACT_APP_API_URL}/statuspages/availability/subdomain`, {
					hosted_subdomain : subdomain,
					statuspage_id : page_id
				} , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
						
					}
				} )
				.then(res => res.data )
				.then(async response => {

					resolve(response)
					
				})
				.catch(error => {

					reject(error) 
				})
			}
		})


	}

	/**
	 * CHECK THE AVAILABILITY OF THE SUBDOMAIN + REGEX
	 */
	const changeSubdomain = async ({ target : { name , value}}) => {

		 

		setIsCheckingSubdomain(true)

		let validationMessage = '';

		value = value.toLowerCase();

		setFormData( (prevState) => ({
			...prevState,
			hosted_subdomain : value
		}))

		// ! Check the syntaxe 
		if(value.match(regex_validator.subdomain)===null){
			validationMessage = 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"'  
			
		}else{
			validationMessage = 'The selected subdomain is not available!'
			// ! Check the availability 
			//console.log('start checking ....');
			try {
				const response = await checkSubdomainAvailability(value)
				
				// //console.log('response : ' , response ); 

				
				if(response && response?.availability === true ) validationMessage = '';
				 

			} catch (error) {

				//console.log('error : ' , error );
			}

			 
		}

		

		 

		setFormValidation((prevState) => ({
			...prevState,
			hosted_subdomain :  validationMessage
		}))

		setIsCheckingSubdomain(false)

	}

	/**
	 * 
	 */
	const onChangeSubdomain = useMemo(
		() => debounce(changeSubdomain, 300)
	  , []); 

	// ! CUSTOM DOMAIN CHECKING ....    
	/**
	 * 
	 * @param {*} customDomain 
	 */
	const checkCustomDomainAvailability = async (customDomain) => {
		
		return new Promise(async (resolve, reject) => { 


	
			if(user && user.token){

				const { token } = user 
	
				await axios
				.post(`${process.env.REACT_APP_API_URL}/statuspages/availability/customdomain`, {
					custom_domain : customDomain,
					statuspage_id : page_id
				} , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
						
					}
				} )
				.then(res => res.data )
				.then(async response => {

					resolve(response)
					
				})
				.catch(error => {

					reject(error) 
				})
			}
		})


	}

	/**
	 * CHECK THE AVAILABILITY OF THE CUSTOM DOMAIN + REGEX
	 */
	const changeCustomDomain = async ({ target : { name , value}}) => {

		 

		setIsCheckingCustomDomain(true)

		let validationMessage = '';

		value = value.toLowerCase();

		setFormData( (prevState) => ({
			...prevState,
			custom_domain : value
		}))

		// ! Check the syntaxe 
		if(value.match(regex_validator.custom_domain)===null){
			validationMessage = 'Invalid domain, must only include letters, numbers and the special symbols "- _"'  
			
		}/* else{
			validationMessage = 'The selected domain is not available!'
			// ! Check the availability 
			//console.log('start checking ....');
			try {
				const response = await checkCustomDomainAvailability(value)
				
				// //console.log('response : ' , response ); 

				
				if(response && response?.availability === true ) validationMessage = '';
				 

			} catch (error) {

				//console.log('error : ' , error );
			}

			 
		} */

		

		 

		setFormValidation((prevState) => ({
			...prevState,
			custom_domain :  validationMessage
		}))

		setIsCheckingCustomDomain(false)

	}

	/**
	 * 
	 */
	const onChangeCustomDomain = useMemo(
		() => debounce(changeCustomDomain, 300)
	  , []); 
	
	/**
	 * 
	 * @param {*} e 
	 */
	const onChange = (e) => {

		switch(e.target.name){
			case "hosted_subdomain" : 
				setFormValidation((prevState) => ({
					...prevState,
					hosted_subdomain : (e.target.value === '') ? "Subdomain can't be blank." : ''
				}))
				
				break;
			 
			
		}

		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: (e.target.type ==='checkbox') ? e.target.checked :  e.target.value,
		}));
	};

	/**
	 * 
	 * @param {*} pageData 
	 * @returns 
	 */
	const updateReduxPageInfo = (data) => {

		// ! Update REDUX > ORG > STATUSPAGES [ ID ]
		dispatch(updateOrganizationPagesByID({
			statuspage_id : page_id ,
			data : {
				id : data?.id,
				name : data?.name,
				organization_legal_name : data?.organization_legal_name,
				website_url : data?.website_url,
				support_url : data?.support_url,
				created_at : data?.created_at,
				type : data?.type,
				custom_domain : data?.custom_domain,
				hosted_subdomain : data?.hosted_subdomain,
				logo : data?.logo,
				favicon : data?.favicon,
				is_active : data?.is_active,
				status : data?.status,
			}
		}))

		 // ! Update the status page in REDUX > AUTH > USER > ORGANIZATIONS > STAUSPAGES
		 dispatch(updateUserOrganizationPageByID({
			organization_id : org?.id ,
			statuspage_id : page_id,
			data : {
				id : data?.id,
				name : data?.name,
				organization_legal_name : data?.organization_legal_name,
				website_url : data?.website_url,
				support_url : data?.support_url,
				created_at : data?.created_at,
				type : data?.type,
				custom_domain : data?.custom_domain,
				hosted_subdomain : data?.hosted_subdomain,
				logo : data?.logo,
				favicon : data?.favicon,
				is_active : data?.is_active,
				status : data?.status,
			}
		}))
	}


	return (
		<>
		<Helmet>
			<title>{`Domains - Page settings - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<form>
			{
				isLoadingStatuspageData === true 
				? 'Loading..'
				: (
					<>

					<Input
						note="Access your status page via a custom subdomain on statusway.co. The subdomain needs to be unique across all Uptime users."
						error={isCheckingSubdomain === true ? 'Checking...' : formValidation?.hosted_subdomain}
						label="Hosted Subdomain"
						placeholder=""
						 
						prefix={<div >https://</div>}
						suffix={<div >{process.env.REACT_APP_STATUSPAGE_HOSTNAME}</div>}
						name="hosted_subdomain"
						onChange={onChangeSubdomain}
						defaultValue={formData?.hosted_subdomain} 
						required
						
						/>
					<Input
						note={formData?.custom_domain === '' 
                            ? `Create a CNAME record pointing to status${process.env.REACT_APP_STATUSPAGE_HOSTNAME} with the "status" value. Initial request takes a few seconds longer due to the SSL registration processed on the fly!`
                            : ''
                        }
						error={isCheckingCustomDomain === true ? 'Checking...' : formValidation?.custom_domain}
						label="Custom domain"
						placeholder=""

						prefix={<div >https://</div>}
						 
						name="custom_domain"
						onChange={onChangeCustomDomain}
						defaultValue={formData?.custom_domain}
						onlyOnPaidPlan={formData?.plan === 'free' ? {
                            feature_name : 'Custom Domain',
                            available_plan : 'Pro',
                            message : 'Upgrade your plan to use a custom domain.',
                            link : `/pages/${page_id}/billing`
                        } : {} }
						/>
					<div className={`dns-domain-config ${formData?.custom_domain === '' ? 'hide' : ''}`}>
						<div className={`dns-note ${formData?.custom_domain_verify_status === 'verified' ? 'verified' : ''}`} >{
							formData?.custom_domain_verify_status === 'verified'
							? <><BsCheckCircleFill />Domain verified</>
							: <>Please point <b>{formData?.custom_domain}</b> to Status Way by configuring the following records.</>
						}</div>
						{
							(formData?.custom_domain_verify_status==='' || ['pending','rejected','missing_txt_record'].includes(formData?.custom_domain_verify_status) ) && 
							<div className='dns-table'>
								<table>
									<thead>
										<tr>
											<th>Record Type</th>
											<th>Host</th>
											<th>Target</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>CNAME</td>
											<td>{formData?.custom_domain}</td>
											<td>status.statusway.co</td>
											<td className='options'>
												<span 
													className="copyContent-btn" 
													title='Copy to clipboard'
													onClick={ () => copyToClipboard(`status.statusway.co`)}><FiCopy /></span>
													
											</td>
										</tr>
										{
											['rejected','missing_txt_record'].includes(formData?.custom_domain_verify_status) && 
											<tr>
												<td>TXT</td>
												<td>_sm</td>
												<td>statusmetrics-domain-verification={formData?.custom_domain_verification_id}</td>
												<td className='options'>
													<span 
														className="copyContent-btn" 
														title='Copy to clipboard'
														onClick={ () => copyToClipboard(`statusmetrics-domain-verification=${formData?.custom_domain_verification_id}`)}><FiCopy /></span>
													<Tooltip 
														placement="left" 
														trigger={['hover']} 
														overlay={<div style={{ maxWidth : 260, padding : 10}}>Another StatusMetrics account is using this domain. Please set the following TXT record on _sm.{getIndexDomainName(formData?.custom_domain)} to use {formData?.custom_domain} in this organization. Once the verification is completed and the domain is successfully configured, the TXT record can be removed.</div>}
														><div className='warning-dns-recors'><IoIosWarning /></div></Tooltip>
													</td>
											</tr>
										}
									</tbody>
								</table>
							</div>
						}
					</div>
					<div className="field-group submit-fields-group fluid form_fixed_footer">
                        <Container className="flex-start">
                            <div   className='form_footer'   >
							    <Button  onClick={onSubmit}  loading={isLoading} >{'Save'}</Button>
                            </div>
                        </Container>
					</div>
					</>)
			}
		</form>	
		</>
	)
}
